import { FederationsService } from './../../../shared/services/federations/federations.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InputParamTrainee } from 'app/shared/models/class/parameter/parameter';
import { SexList } from 'app/shared/models/class/sex-list/sex-list';
import { Trainee } from 'app/shared/models/class/trainee/trainee';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { SexListService } from 'app/shared/services/sex-list/sex-list.service';
import { TraineeService } from 'app/shared/services/trainee/trainee.service';
import { Licence } from 'app/shared/models/class/federation/federation';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';
import { OpenDialogHelpComponent } from '../open-dialog-help/open-dialog-help.component';

interface DialogData {
  action: string;
  trainee: Trainee;
  userKey: number;
  sessionKey?: number;
}

type switchOptions = {
  [key: string]: any
};

@Component({
  selector: 'app-opendialog-add-edit-trainee',
  templateUrl: './opendialog-add-edit-trainee.component.html',
  styleUrls: ['./opendialog-add-edit-trainee.component.scss']
})
export class OpendialogAddEditTraineeComponent extends SubscriptionBaseComponent implements OnInit {

  traineeForm: UntypedFormGroup;
  title: string;
  btnConfirm: string;
  today = new Date();
  city: string;
  sexTraineeSelected: number;
  color: ThemePalette = 'primary';
  sexList: any;
  inputsParamOffer: InputParamTrainee[] = [];
  licences: Licence[] = [];
  filteredLicences: Licence[] = [];

  isLoadingLicences = false;
  isMobile = false;

  constructor(
    private formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<OpendialogAddEditTraineeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private authService: AuthService,
    private traineeService: TraineeService,
    private sexListService: SexListService,
    private faIconService: FaiconService,
    private federationsSrv: FederationsService,
    private dialog: MatDialog
  ) {
    super()
  }

  ngOnInit(): void {
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
     this.isMobile = true;
    }else{
      this.isMobile = false;
    }

    this.initComponent();
    this.initSub();

  }

  initSub() {
    this.isLoadingLicences = true;
    this.subscription.add(
      this.federationsSrv.getLicences().subscribe(licencesFromSrv => {
        this.licences = licencesFromSrv;
        this.filteredLicences = [...this.licences];
        this.isLoadingLicences = false;
        this.initForm();
      })
    )
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  //TODO isDefault à true/false
  // regex retirer ; et # dans le champs de la valeur du paramètre
  onSubmit(): void {
    const userKey = this.data.userKey ? this.data.userKey : this.authService.getDecodedToken().sub;
    const city = this.city ? this.city : this.f.city.value;
    let parameterValues = null;
    if (this.data.action === 'edit') {
      parameterValues = this.f.parameterValues.value;
    }
    let trainee: Trainee;
    if (parameterValues?.length > 0) {
      trainee = new Trainee(+userKey, this.f.firstname.value, this.f.lastname.value, this.f.postalCode.value, city, this.f.birthDate.value, this.sexTraineeSelected, this.f.emergencyPhoneNumber.value.join(";"), this.f.licenceValues.value, parameterValues);
    } else {
      trainee = new Trainee(+userKey, this.f.firstname.value, this.f.lastname.value, this.f.postalCode.value, city, this.f.birthDate.value, this.sexTraineeSelected, this.f.emergencyPhoneNumber.value.join(";"), this.f.licenceValues.value);
    }

    if (this.data.sessionKey) {
      trainee.sessionKey = this.data.sessionKey;
    }

    switch (this.data.action) {
      case 'add':
        this.traineeService.addTrainee(trainee).subscribe({
          next: () => {
            this.dialogRef.close(trainee);
          }
        });
        break;

      case 'edit':
        trainee.traineeKey = this.data.trainee.traineeKey;
        this.traineeService.updateTrainee(trainee).subscribe({
          next: () => { this.dialogRef.close(trainee); }
        });
        break;

      default:
        break;
    }

  }

  getAddressPracticePlace(event) {
    const cp = event.address_components.filter(el => el.types.join('#').includes('postal_code'))[0];
    cp ? this.f.postalCode.setValue(cp.long_name) : this.f.postalCode.reset();
    this.city = event.address_components.filter(el => el.types.join('#').includes('locality'))[0].long_name;
  }

  test(event): void {
    const input = document.getElementById('birthDate');
    input.innerHTML = this.f.birthDate.value;
    // this.f.birthDate.setValue(new Date(event.target.value))
  }

  private getLabel(type: string): string {
    const label: switchOptions = {
      add: {
        title: 'Ajouter un stagiaire',
        confirm: 'Ajouter le stagiaire',
      },
      edit: {
        title: 'Modifier un stagiaire',
        confirm: 'Modifier le stagiaire',
      },
    };
    return label[this.data.action][type];
  }

  private getSexList(): void {
    this.sexListService.getSexList().subscribe({
      next: sexList => {
        this.sexList = sexList;
        this.sexTraineeSelected = !!this.data.trainee ? this.data.trainee.sexKey : sexList[0].sexKey;
      }
    });
  }

  private initComponent(): void {
    this.title = this.getLabel('title');
    this.btnConfirm = this.getLabel('confirm');
    this.getSexList();
  }

  get f() {
    return this.traineeForm.controls;
  }

  private initForm(): void {
    this.inputsParamOffer = [];

    this.traineeForm = this.formBuilder.group({
      firstname: [this.data.trainee ? this.data.trainee.traineeFirstName : '', Validators.required],
      lastname: [this.data.trainee ? this.data.trainee.traineeLastName : '', Validators.required],
      postalCode: [this.data.trainee ? this.data.trainee.traineePostalCode : '', Validators.required],
      city: [this.data.trainee ? this.data.trainee.traineeCity : '', Validators.required],
      birthDate: [this.data.trainee ? new Date(this.data.trainee.traineeBirthDate) : '', Validators.required],
      // emergencyPhoneNumber: [this.data.trainee ? this.data.trainee.emergencyPhoneNumber : '', Validators.required],
      emergencyPhoneNumber: this.formBuilder.array([]),
      parameterValues: this.formBuilder.array([]),
      licenceValues: this.formBuilder.array([])
    });

    if (this.data?.trainee?.emergencyPhoneNumber) {
      let numbers = this.data.trainee.emergencyPhoneNumber.split(';');
      numbers.map(number => {
        this.addEmergencyPhoneNumber(number);
      })
    } else {
      this.addEmergencyPhoneNumber();
    }

    if (this.data?.trainee?.licences) {
      this.data?.trainee?.licences.map(licence => {
        this.onAddLicence(licence);
      })
    }


    if (this.data?.trainee?.parameters?.length > 0) {
      const valuesParamsOffer = [];

      for (let i = 0; i < this.data.trainee.parameters.length; i++) {
        const input = {
          label: this.data.trainee.parameters[i].label,
          selectedValue: this.data.trainee.parameters[i].selectedValue,
          isDefault: this.data.trainee.parameters[i].isDefault
        };
        valuesParamsOffer.push(input);
      }

      this.data.trainee?.parameters?.forEach((p, i) => {

        this.addParameterItem();
        const input: InputParamTrainee = {
          label: p.label,
          type: p.type,
          values: this.getValueInputForm(p.values as string),
          isDefault: p.isDefault,
          input: valuesParamsOffer ?
            this.createParameterItem(i, valuesParamsOffer[i], p.type, p.parameterKey, p, p.isDefault) : this.createParameterItem(i),
          parameterKey: p.parameterKey
        };
        this.inputsParamOffer.push(input);
      });

      this.inputsParamOffer.map((input, index) => {
        this.getArray('parameterValues').controls[index].get('selectedValue').setValue(valuesParamsOffer[index].selectedValue);
        this.getArray('parameterValues').controls[index].get('parameterKey').setValue(input.parameterKey);
        this.getArray('parameterValues').controls[index].get('isDefault').setValue(input.isDefault);
      })



      this.data.trainee?.parameters?.forEach((p, i) => {
        if (p.type === 'valeur min/max') {
          let min = parseInt(p.values.toString().split('#')[0]);
          let max = parseInt(p.values.toString().split('#')[1]);
          this.getArray('parameterValues').controls[i].get('selectedValue').setValidators([Validators.required, Validators.min(min), Validators.max(max)])
        }
      });
    }


  }

  getArray(array: string): UntypedFormArray {
    return this.traineeForm.get(array) as UntypedFormArray;
  }

  addEmergencyPhoneNumber(number?): void {
    let theNumber = number ? this.formBuilder.control(number) : this.formBuilder.control(null);

    theNumber.setValidators(Validators.required);

    this.getArray('emergencyPhoneNumber').push(theNumber);
  }

  removeEmergencyPhoneNumber(index) {
    this.getArray('emergencyPhoneNumber').removeAt(index);
  }

  addParameterItem(): void {
    this.getArray('parameterValues').push(this.createParameterItem());
  }

  setValueInput(index: number, event, parameterKey: number, select: boolean = false): void {
    const valueInput = !select ? event.target.value : event;
    this.getArray('parameterValues').controls[index].get('selectedValue').setValue(valueInput);
    this.getArray('parameterValues').controls[index].get('parameterKey').setValue(parameterKey);
  }

  changeIsDefault(index, event) {
    this.getArray('parameterValues').controls[index].get('isDefault').setValue(event.checked);
  }


  private createParameterItem(index?: number, selectedValue: { label: string, selectedValue: any | string[]; } = null, type: string = 'other', parameterKey?: number, parameter?, isDefault?): UntypedFormGroup {
    const valueChecked = selectedValue !== null ? selectedValue.selectedValue : '';
    let newFormControl = null;
    switch (type) {
      case 'valeur min/max':
        let min = parameter.values.split('#')[0];
        let max = parameter.values.split('#')[1];
        newFormControl = this.formBuilder.group({ selectedValue: [+valueChecked, [Validators.required, Validators.min(min), Validators.max(max)]], parameterKey: parameterKey, isDefault: isDefault })
        break;

      case 'date':
        newFormControl = this.formBuilder.group({ selectedValue: [new Date(valueChecked), [Validators.required, Validators.pattern("[^;#]+")]], parameterKey: parameterKey, isDefault: isDefault })
        break;

      default:
        newFormControl = this.formBuilder.group({ selectedValue: [valueChecked, [Validators.required, Validators.pattern("[^;#]+")]], parameterKey: parameterKey, isDefault: isDefault })
        break;
    }
    return newFormControl;
  }

  private getValueInputForm(values: string): string[] {
    const arrayValue: string[] = values.split('#');
    return arrayValue;
  }

  onAddLicence(licence?): void {
    let theLicence = licence ? this.licences?.find(pp => pp?.licenceKey === licence?.licenceKey) : null;
    let licenceKey = licence ? licence.licenceKey : null;
    let value = licence ? licence.licenceValue : null;

    const newGroup = this.formBuilder.group({
      licence: [theLicence, [Validators.required]],
      licenceKey: [licenceKey, [Validators.required]],
      value: [value, [Validators.required]]
    });

    newGroup.get('licence').valueChanges.subscribe(value => {
      if (typeof value !== 'string') {
        newGroup.get('licenceKey').setValue(value.licenceKey);
        let paramsSelected = [];
        this.f.licenceValues.value.map(oneSelected => {
          paramsSelected.push(oneSelected.licenceKey);
        })
        this.filteredLicences = [...this.licences].filter((param) => !paramsSelected.includes(param.licenceKey));
      }
    })

    this.getArray('licenceValues').push(newGroup);

    let paramsSelected = [];
    this.f.licenceValues.value.map(oneSelected => {
      paramsSelected.push(oneSelected.licenceKey);
    })
    this.filteredLicences = [...this.licences].filter((param) => !paramsSelected.includes(param.licenceKey));
  }

  onRemoveLicence(index: number): void {
    this.getArray('licenceValues').removeAt(index);

    let paramsSelected = [];
    this.f.licenceValues.value.map(oneSelected => {
      paramsSelected.push(oneSelected.licenceKey);
    })
    this.filteredLicences = [...this.licences].filter((param) => !paramsSelected.includes(param.licenceKey));
  }

  openDialogHelp() {
    this.dialog.open(OpenDialogHelpComponent, {
      data: { helpVideoKey: 2 },
      width: '60%',
      maxHeight: '90%'
    });
  }

}
